import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import styles from "./ActionButton.module.scss";

export default function ActionButton(props) {
  const { children, selected, variant, classes, linkTo, href, target, ...rest } = props;

  return (
    <button
      className={clsx(
        styles.btn,
        classes && classes.root,
        selected && styles.selected,
        variant === "subtle" && styles.subtle
      )}
      {...rest}
    >
      {linkTo ? <Link to={linkTo}>{children}</Link> : (
        href ? <a href={href} target={target}>{children}</a> : <span>{children}</span>)}
    </button>
  );
}
